/* src/interviews/components/AvailabilityHeader/index.js */

import React from 'react';
// import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { Add } from '@material-ui/icons';

import { PaperHeader, TabBar } from '../../../../app/components';
import styles from './styles';

class AvailabilityHeader extends React.PureComponent {
  render() {
    const { classes, onExpand, onTab, value, expanded } = this.props;
    return (
      <React.Fragment>
        <PaperHeader text="Interview Availability">
          <Button
            className={classes.expand}
            variant="fab"
            color="primary"
            mini
            aria-expanded={expanded}
            aria-label="Show more"
            onClick={onExpand}
          >
            <Add />
          </Button>
        </PaperHeader>
        <TabBar
          onChange={onTab}
          fullWidth
          labels={['Schedule', 'Location']}
          value={value}
        />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(AvailabilityHeader);



// WEBPACK FOOTER //
// ./src/modules/interviews/components/AvailabilityHeader/index.js